import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { rgba } from 'polished';
import styled from 'styled-components';
import { buttonTheme } from '../ButtonShared.styles';
const Button = styled.a `
  display: inline-flex;
  border: 0;
  background-color: var(--buttonBgColor);
  border: 1px solid var(--buttonBorderColor);
  color: var(--buttonColor);
  margin: 0;
  outline: none;
  padding: 12px 28px;
  place-content: center;
  place-items: flex-start;
  text-decoration: none;
  transition: background-color 0.15s ease-out, background-size 0.15s ease-out,
    border-color 0.15s ease-out, color 0.15s ease-out, opacity 0.15s ease-out,
    transform 0.15s ease-out;
  user-select: none;
  width: auto;

  &:disabled {
    opacity: 0.5;
  }

  &:focus {
    outline: none;
  }

  &[data-theme='black'] {
    ${buttonTheme({
    bgColor: brand.black,
    borderColor: brand.black,
    fgColor: brand.white,
})}

    &:focus,
    &:hover {
      ${buttonTheme({
    bgColor: brand.white,
    borderColor: brand.black,
    fgColor: brand.black,
})}
    }
  }

  &[data-theme='blackOutline'] {
    ${buttonTheme({
    bgColor: rgba(brand.black, 0),
    borderColor: brand.black,
    fgColor: brand.black,
})}

    &:focus,
    &:hover {
      ${buttonTheme({
    bgColor: brand.black,
    borderColor: brand.black,
    fgColor: brand.white,
})}
    }
  }

  &[data-theme='brown'] {
    ${buttonTheme({
    bgColor: brand.brown,
    borderColor: brand.brown,
    fgColor: brand.white,
})}

    &:focus,
    &:hover {
      ${buttonTheme({
    bgColor: brand.white,
    borderColor: brand.brown,
    fgColor: brand.brown,
})}
    }
  }

  &[data-theme='brownOutline'] {
    ${buttonTheme({
    bgColor: rgba(brand.brown, 0),
    borderColor: brand.brown,
    fgColor: brand.brown,
})}

    &:focus,
    &:hover {
      ${buttonTheme({
    bgColor: brand.brown,
    borderColor: brand.brown,
    fgColor: brand.white,
})}
    }
  }

  &[data-theme='white'] {
    ${buttonTheme({
    bgColor: brand.white,
    borderColor: brand.white,
    fgColor: brand.black,
})}

    &:focus,
    &:hover {
      ${buttonTheme({
    bgColor: brand.black,
    borderColor: brand.white,
    fgColor: brand.white,
})}
    }
  }

  &[data-theme='whiteOutline'] {
    ${buttonTheme({
    bgColor: rgba(brand.white, 0),
    borderColor: brand.white,
    fgColor: brand.white,
})}

    &:focus,
    &:hover {
      ${buttonTheme({
    bgColor: brand.white,
    borderColor: brand.white,
    fgColor: brand.black,
})}
    }
  }
`;
const Icon = styled.span `
  display: block;
  height: 23px;
  margin: 0 12px 0 0;
  width: 23px;
`;
const Content = styled.span `
  display: block;
`;
const Text = styled.span `
  display: block;
  ${fonts.gillSans.regular};
  font-size: 19px;
  line-height: 20px;
`;
const Meta = styled.span `
  display: flex;
  ${fonts.gillSans.light};
  font-size: 19px;
  line-height: 20px;
`;
const Format = styled.span `
  display: inline-block;
  margin-right: 4px;
`;
const Size = styled.span `
  display: inline-block;
  margin-right: 4px;
`;
export default {
    Button,
    Content,
    Format,
    Icon,
    Meta,
    Size,
    Text,
};
